import { Injectable } from '@angular/core';
import { Workbook, Cell, Style } from 'exceljs';
import { json } from '../../assets/data/routemee';
import * as fs from 'file-saver';
import { ExcelTitle, ExcelColumns } from '../interfaces/excel.interface';
import { isObject } from 'util';
@Injectable()
export class ExcelService {
  public colorApp = String(json['tableColor']).replace('#', '');
  constructor() { }

  generateExcel(titulo: ExcelTitle, columns: ExcelColumns, rows: any, frozen?: any, summary?: any): Promise<any> {
    return new Promise((resolve) => {
      const title = titulo.title;
      const header = columns.columns;
      const data = rows;
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet(title.length > 20 ? 'Datos' : title);

      const sumaryStyleLabel: Partial<Style> = {
        font: {color : {argb: "F7F9F9"}},
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: `595959` },
          bgColor: { argb: `595959` }
        },
        border: {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        },
        alignment: {horizontal: 'center'}
      }

      const summaryStyleValue: Partial<Style> = {
        font: {bold: true, },
        // fill: {
        //   type: 'pattern',
        //   pattern: 'solid',
        //   fgColor: { argb: `85C1E9` },
        //   bgColor: { argb: `85C1E9` }
        // },
        border: {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        }
      }
    
      if(summary){
        const labels1 = [2,5,8]
        const row1 = worksheet.addRow(['','CAPITAL COBRADO',, summary.capital_cobrado, 'INTERES COBRADO',, summary.interes_cobrado, 'UTILIDAD BRUTA',,
        summary.interes_cobrado +summary.gastos_cierre +summary.moras_cobradas + summary.cobrado_incobrables])
        row1.eachCell(
          (cell: Cell, index: number) => {
            if(labels1.includes(index) ) {
              cell.style = sumaryStyleLabel
              
            }else{
              cell.style = summaryStyleValue
              index == 1 ? cell.style.border = { } : null
              cell.numFmt = '$#,##0.00;[Red]-$#,##0.00';
            }
        })
        worksheet.mergeCells('B1:C1')
        worksheet.mergeCells('E1:F1')
        worksheet.mergeCells('H1:I1')

        const labels2 = [2,5,8]
        const row2 = worksheet.addRow(['','GASTO DE CIERRE',, summary.gastos_cierre, 'MORAS COBRADAS',, summary.moras_cobradas, 'TOTAL DE GASTOS',, summary.total_gastos])
        row2.eachCell(
          (cell: Cell, index: number) => {
            if(labels2.includes(index) ) {
              cell.style = sumaryStyleLabel
              
            }else{
              cell.style = summaryStyleValue
              index == 1 ? cell.style.border = { } : null
              index == 10 ? cell.style = {font: {color : {argb: "D12939"}, bold: true}} : null
              // index == 10 ? cell.style.font =  {color : {argb: "D12939"}} : cell.style.font =  {color : {argb: "F7F9F9"}}
              cell.numFmt = '$#,##0.00;[Red]-$#,##0.00';
              
            }
        })
        worksheet.mergeCells('B2:C2')
        worksheet.mergeCells('E2:F2')
        worksheet.mergeCells('H2:I2')

        const labels3 = [2,5,8] 
        const row3 = worksheet.addRow(['','COBRADO INCOBRABLE', ,summary.cobrado_incobrables ,'TOTAL COBRADO', ,
        summary.capital_cobrado +
        summary.interes_cobrado +
        summary.gastos_cierre +
        summary.moras_cobradas  ,'Pérdida'.toUpperCase(),,summary.perdida_incobrables ])
        row3.eachCell(
          (cell: Cell, index: number) => {
            if(labels3.includes(index) ) {
              cell.style = sumaryStyleLabel
              
            }else{
              cell.style = summaryStyleValue
              index == 1 ? cell.style.border = { } : null
              index == 10 ? cell.style = {font: {color : {argb: "D12939"}, bold: true}} : null
              cell.numFmt = '$#,##0.00;[Red]-$#,##0.00';
            }
        })
        worksheet.mergeCells('B3:C3')
        worksheet.mergeCells('E3:F3')
        worksheet.mergeCells('H3:I3')

       const row4 = worksheet.addRow(['',,,,,,, 'Utilidad Neta / Beneficios'.toUpperCase(),,
                    summary.interes_cobrado +
                    summary.gastos_cierre +
                    summary.moras_cobradas - 
                    summary.total_gastos -
                    summary.perdida_incobrables +
                    summary.cobrado_incobrables ])
       row4.eachCell(
        (cell: Cell, index: number) => {
          if(labels3.includes(index) ) {
            cell.style = sumaryStyleLabel
            
          }else{
            cell.style = summaryStyleValue
            index == 1 ? cell.style.border = { } : null
            index == 10 ? cell.style = {font: {color : {argb: "84D100"}, bold: true}} : null
            cell.numFmt = '$#,##0.00;[Red]-$#,##0.00';
          }
      })
      //  worksheet.mergeCells('C4:D4')
       worksheet.mergeCells('H4:I4')
       
       worksheet.addRow([''])

       worksheet.mergeCells('A1:A5')
       
        
      }

      if (header.length && data.rows.length) {
        // Add Header Row
        const headerRow = worksheet.addRow(header);

        // Cell Style : Fill and Border
        headerRow.eachCell((cell, index) => {
          cell.style = {
            font: {bold: true},
            fill: {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: `85C1E9` },
              bgColor: { argb: `85C1E9` }
            },
            border: {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' }
            }
          }
        });

      }

      for (const i in columns.columnOptions) {
        for (const key in columns.columnOptions[i].properties) {
          worksheet.getColumn(columns.columnOptions[i].key)[key] = columns.columnOptions[i].properties[key];
        }
      }

      if (frozen) {
        worksheet.views = [frozen];
      }


      for (const items of data.rows) {
        let properties;
        // tslint:disable-next-line:forin
        for (const i in items) {
          if (isObject(items[i])) {
            if (items[i].hasOwnProperty('properties')) {
              properties = items[i].properties;
              items.splice(i, 1);
              break;
            }
          }
        }

        const row = worksheet.addRow(items);
        row.alignment = { wrapText: true, vertical: 'middle'};
        if (properties) {
          row.eachCell( (cell: Cell, col: number) => {
            cell.font = properties.font;
            cell.border = properties.border;
            if (properties.fill.hasOwnProperty('fgFirst') && col === 1) {
              cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: properties.fill.fgFirst
              };
            } else if (properties.fill.hasOwnProperty('fgLast') && col == items.length) {
              cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: properties.fill.fgLast
              };
            } else {
              cell.fill = properties.fill;
            }
          });
          if (properties.hasOwnProperty('height')) {
            row.height = properties.height;
          }
        }
      }

      workbook.xlsx.writeBuffer().then((res: any) => {
        const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        fs.saveAs(blob, title.replace(/\s+/g, ' ').toLowerCase() + '.xlsx');
        resolve('OK');
      });
    });

  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/services/excel.service.ts